module.exports = __webpack_public_path__ + "assets/img/btn-detail-3e7028c2.png";